<form [formGroup]="form" (submit)="onOkClick()">
  <h1 mat-dialog-title>Accesorii pe latura {{data.side.name}}</h1>
  <div mat-dialog-content>
    <mat-form-field appearance="fill">
      <mat-label>Accesorii</mat-label>
      <mat-select #accessories formControlName="accessories" [multiple]="true">
        <mat-option *ngFor="let type of accessoryTypes" [value]="type.key">{{type.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-raised-button color="primary" [disabled]="!form.valid" (click)="onOkClick()">Salvează</button>
    <button mat-button mat-raised-button mat-dialog-close>Înapoi</button>
  </div>
</form>
